// studentsSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { fetchStudents } from './studentsAPI';

const studentsSlice = createSlice({
  name: 'students',
  initialState: {
    students: [], // Initialize as an empty array
    status: 'idle',
    error: null,
  },
  reducers: {
    updateStudents: (state, action) => {
      state.students = action.payload;
      state.status = 'succeeded';
    },
  },
});

export const { updateStudents } = studentsSlice.actions;

// Thunk function to fetch students from the API
export const fetchStudentsAsync = (token) => async (dispatch) => {
  try {
    const students = await fetchStudents(token);
    dispatch(updateStudents(students));
  } catch (error) {
    console.error('Failed to fetch students:', error);
  }
};

export const selectStudents = (state) => state.students.students;

// Define selectFilteredStudents selector
export const selectFilteredStudents = (state) => {
  // Implement your filtering logic here
  // For now, returning all students
  return state.students.students;
};

export default studentsSlice.reducer;
